<template>
  <div>
    <transition name="bounce">
      <div v-if="showNotification" class="company-change-notification">
        <div class="d-flex align-items-center notification-container">
          <div class="d-flex flex-column">
            <div class="update-text">
              <h6 class="mb-0 font-weight-midbold">{{ $t('extra.company_change_notification') }}</h6>
            </div>
          </div>

          <s-button class="update-btn-black ml-2" @click="reloadPage">
            <refresh-icon class="text-white"/>
            <span class="font-weight-midbold">{{ $t('actions.update') }}</span>
          </s-button>
        </div>

        <progress-animation-bar v-if="companyOwnerChanged" @end="reloadPage" :animation-duration="secondsBeforeRefresh" class="mt-2"/>
      </div>
    </transition>
  </div>
</template>
<script setup>
  import RefreshIcon from '@/components/icons/refresh.vue';
  import { useUpdateStore } from '@/stores/update';
  import { computed, ref } from 'vue';
  import { useAuthStore } from '@/stores/auth.ts';
  import ProgressAnimationBar from '@/components/progress/progress-animation.vue';

  const secondsBeforeRefresh = ref(60);
  const updateStore = useUpdateStore();
  const authStore = useAuthStore();

  const companyChanged = computed(() => updateStore.active_company_mismatch);
  const companyOwnerChanged = computed(() => updateStore.company_owner_changed);
  const subscriptionUpdated = computed(() => authStore.subscription_mismatch);
  const releaseUpdated = computed(() => updateStore.mismatch || updateStore.refresh_version_mismatch);
  const featureFlagChanged = computed(() => authStore.feature_flags_changed);

  const showNotification = computed(() => (companyChanged.value || companyOwnerChanged.value) && !subscriptionUpdated.value && !releaseUpdated.value && !featureFlagChanged.value);

  function reloadPage() {
    window.location.reload();
  }
</script>
